import React from "react";
import { Flex } from "../../../../../components/Flex";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Info } from "../../../../../components/Info";
import { Spacing } from "../../../../../theme/Spacing";
import { Rounded } from "../../../../../theme/Rounded";
import { Text } from "../../../../../components/Text";
import { useSettingsAIChatbotContext } from "../../../sections/SettingsAIChatBot";
import { CopyButton } from "../../../../../components/CopyButton";
import { Images } from "../../../../../assets";
import { AtiraImage } from "../../../../../components/Image";

const LinkContainer = styled(Flex)`
  background-color: ${({ theme }) => theme.sub};
  border-end-start-radius: ${Rounded.md};
  border-start-start-radius: ${Rounded.md};
  padding: ${Spacing.s};
  width: 100%;

  html[dir="rtl"] & > p {
    margin-right: auto;
  }
`;

const CopyButtonWrapper = styled(Flex)`
  button {
    border-start-start-radius: 0;
    border-end-start-radius: 0;
  }
`;

const StyledImage = styled(AtiraImage)`
  border: 1px solid ${({ theme }) => theme.main};
  border-radius: ${Rounded.sm};
`;

export const SettingsAIChatBotShareDrawerHTML: React.FC = () => {
  const { t } = useTranslation();
  const { currentBot } = useSettingsAIChatbotContext();

  const botHTML = `<div data-atira-bot="${currentBot?._id}" id="${currentBot?._id}"></div>`;
  const generatedScript = `<script defer src="${process.env.REACT_APP_API_URL}/chatbot/${currentBot!._id}/generate/input-mode"></script>`;

  return (
    <Flex flexDirection="column" gap="l">
      <Text fontWeight={"bold"}>
        {t("settings.aiChatbot.share.tabs.html.title")}
      </Text>

      <Info info={t("settings.aiChatbot.share.tabs.html.info")} />

      <hr />
      <Flex flexDirection="column" gap="xs">
        <Info
          info={t("settings.aiChatbot.share.tabs.html.info.details.step.1")}
        />
        <Flex>
          <LinkContainer>
            <Text wordBreak="break-all" direction="ltr">
              {botHTML}
            </Text>
          </LinkContainer>
          <CopyButtonWrapper>
            <CopyButton copy={botHTML} asText />
          </CopyButtonWrapper>
        </Flex>
      </Flex>

      <Flex flexDirection="column" gap="xs">
        <Info
          info={t("settings.aiChatbot.share.tabs.html.info.details.step.2")}
        />
        <Flex>
          <LinkContainer>
            <Text wordBreak="break-all" direction="ltr">
              {generatedScript}
            </Text>
          </LinkContainer>
          <CopyButtonWrapper>
            <CopyButton copy={generatedScript} asText />
          </CopyButtonWrapper>
        </Flex>
      </Flex>

      <Flex flexDirection="column" gap="s">
        <Text>{t("common.example")}</Text>
        <StyledImage src={Images.AIChatbotHTML1} alt="Chatbot HTML Example" />
        <StyledImage src={Images.AIChatbotHTML2} alt="Chatbot HTML Example" />
      </Flex>
    </Flex>
  );
};
